module.exports = __webpack_public_path__ + "static/media/11-quiz.66f19765.png";